<template>
  <div class="row">
    <div class="col-12">
      <h4 class="text-center mb-3">Tipos de equipamento</h4>
      <DataTable
        :value="machine_classes"
        :lazy="true"
        :paginator="true"
        :rows="10"
        :loading="loading"
        :total-records="total_machine_classes"
        class="p-datatable-gridlines p-datatable-sm"
        data-key="id"
        :row-hover="true"
        ref="datatable"
        @page="onPage($event)"
        @sort="onSort($event)"
      >
        <template #empty> Nenhum resultado </template>
        <template #loading> Carregando </template>
        <Column field="name" header="Nome"></Column>
        <Column field="description" header="Descrição"></Column>
        <Column header="Ativo">
          <template #body="{ data }">
            <p v-if="data.active == 1" class="text-success">Sim</p>
            <p v-else class="text-danger">Não</p>
          </template>
        </Column>
        <Column>
          <template #body="slotProps">
            <div class="d-flex flex-nowrap justify-content-end">
              <router-link :to="'/machine-classes/edit/' + slotProps.data.id">
                <button class="btn btn-warning ml-3">
                  <font-awesome-icon
                    :icon="['fas', 'wrench']"
                  ></font-awesome-icon>
                </button>
              </router-link>

              <button
                class="btn btn-danger ml-3"
                @click="onDelete(slotProps.data.id, slotProps.index)"
              >
                <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
              </button>
            </div>
          </template>
        </Column>
      </DataTable>

      <router-link to="/machine-classes/create" class="btn btn-dark mt-3">
        <font-awesome-icon :icon="['fas', 'save']"></font-awesome-icon>
        Novo tipo de equipamento
      </router-link>
    </div>
  </div>
</template>

<script>
  import DataTable from 'primevue/datatable'
  import Column from 'primevue/column'
  import { ref, onMounted } from 'vue'
  import useMachineClass from '@/modules/MachineClass.js'
  import useSwal from '@/modules/Swal.js'

  export default {
    components: {
      DataTable,
      Column,
    },
    setup() {
      const page = ref(1)
      const per_page = ref(10)
      const datatable = ref(null)

      const {
        machine_classes,
        destroyMachineClass,
        listMachineClasses,
        total_machine_classes,
        loading,
      } = useMachineClass()

      const onPage = (event) => {
        page.value = event.page + 1

        listMachineClasses(page.value, per_page.value)
      }

      const { showConfirmDeletionSwal } = useSwal()

      onMounted(async () => {
        await listMachineClasses(page.value, per_page.value)
      })

      return {
        loading,
        datatable,
        total_machine_classes,
        machine_classes,
        onPage,
        destroyMachineClass,
        showConfirmDeletionSwal,
      }
    },
    methods: {
      onDelete(company_id, index) {
        this.showConfirmDeletionSwal()
          .then((response) => {
            if (response.isConfirmed) {
              this.destroyMachineClass(company_id, index)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
    },
  }
</script>
